import React from "react";
import { Box } from "@mui/material";

const GlobalBanner = ({ backgroundImage, children, sx = {} }) => {
  return (
    <Box sx={{ width: "100%", ...sx }}>
      <Box
        sx={{
          position: "relative",
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: {
            xs: "contain",
            sm: "contain",
            md: "cover",
            lg: "cover",
          },
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          width: "100%",
          height: { xs: "200px", sm: "300px", md: "380px", lg: "380px" }, // Responsive heights
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default GlobalBanner;
